import moment from 'moment';
import { AddlFieldType, TagFieldNames } from 'shared/constants/fields';
import {
  DEFAULT_DATE_FORMAT,
  DEFAULT_TIME_FORMAT,
} from 'shared/constants/misc';
import { isNilOrEmptyIterables } from './functions';

export function domProps(props) {
  return Object.fromEntries(
    Object.entries(props).filter(([key]) =>
      ['id', 'className', 'style', 'type', 'htmlFor', 'onWheel'].includes(key)
    )
  );
}

export function isTagsField(field) {
  return (
    field.fieldType === AddlFieldType.TAG && field.name === TagFieldNames.TAGS
  );
}

export function getDateFormat(isDateTime = false) {
  return isDateTime
    ? `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`
    : DEFAULT_DATE_FORMAT;
}

export function toLocalDate(dateStr, isDateTime = false) {
  if (!dateStr) return null;

  const dt = moment.utc(dateStr, getDateFormat(isDateTime));
  if (!dt.isValid()) return null;

  return dt.local();
}

export function fromLocalDate(dateStr, isDateTime = false) {
  if (!dateStr) return null;

  const dateFormat = getDateFormat(isDateTime);
  const isMoment = moment.isMoment(dateStr);
  const dt = isMoment ? dateStr : moment(dateStr, dateFormat);
  if (!dt.isValid()) return null;

  const formatted = dt.utc().format(dateFormat);
  return formatted;
}

export function toSelectOptions(value) {
  return Array.isArray(value)
    ? value.map(toSelectOptions)
    : { label: value, value };
}

export function toObjRelSelectOptions(value) {
  const values = Object.entries(value).map(([key, val]) => ({
    value: key,
    // Note: Can also do: val.replace(`${key} `, '').replace(`— `, ''),
    label: val.split('—').at(-1).trim(),
  }));
  return values.length === 1 ? values.at(0) : values;
}

export function parseObjRelDefault(obj, fallback) {
  if (isNilOrEmptyIterables(obj)) return fallback || null;

  const entries = Object.entries(obj);
  const result = entries.map(([key, val]) => {
    const stringValue = String(val);
    const numericValue = parseInt(key, 10);
    const value = isNaN(numericValue) ? key : numericValue;

    let label = stringValue;
    const separator = ' — ';
    const separatorIndex = stringValue.indexOf(separator);

    if (separatorIndex !== -1) {
      label = stringValue.substring(separatorIndex + separator.length);
      if (!label || label.trim() === '') {
        label = stringValue;
      }
    }

    // Remove parentheses and the content within
    label = label.replace(/\s*\([^)]*\)/g, '').trim();

    return { label, value };
  });

  return entries.length === 1 ? result.at(0) : result;
}
